module.exports = __webpack_public_path__ + "static/media/website-banner1.1763c9b0.jpg";